import { tv, type VariantProps } from "tailwind-variants";

export const hamburger = tv({
  slots: {
    base: [
      "flex",
      "place-items-center",
      "shrink-0",
      "justify-center",
      "w-10 h-10",
      "p-0.5",
      "rounded-full",
      "shadow-none outline-none appearance-none",
      "cursor-pointer",
      "bg-neutral-dark-alpha/8",
      "border",
      "border-neutral-dark-alpha/10 ",
      "dark:border-neutral-dark-alpha/20",
    ],
    bar: [
      "relative",
      "h-0.5",
      'before:content[""] before:absolute before:h-full before:-top-1.5',
      'after:content[""] after:absolute after:h-full after:-bottom-1.5',

      "block w-4.5 rounded-sm",
      "bg-black dark:bg-static-black-soft",
      "transition duration-300 ease-out",

      "before:block before:w-full before:rounded-sm",
      "before:bg-black dark:before:bg-static-black-soft",
      "before:transition before:duration-300 before:ease-out",

      "after:block after:w-full after:rounded-sm",
      "after:bg-black dark:after:bg-static-black-soft",
      "after:transition after:duration-300 after:ease-out",
    ],
  },
  variants: {
    active: {
      true: {
        bar: [
          "rotate-45",
          "before:rotate-90 before:top-0",
          "after:rotate-90 after:bottom-0",
        ],
      },
    },
  },
});

export type HamburgerVariantProps = VariantProps<typeof hamburger>;
